
Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.FilterBy = (function () {

    function FilterBy (manager, uuid) {

        this.filter = {};
        this.rootEl = document.createElement('div');
        this.rootEl.className = 'addNewAttribute';
        var entity = manager.entityToAction;
        var fieldContainerClass = 'fieldContainer';
        var defaultTypes = ['LOOKUP', 'LOOKUP_LIST', 'PICKLIST', 'DISTANCE', 'CHECKBOX', 'INTEGER', 'SECONDS', 'TEXT', 'DATE_TIME', 'DECIMAL'];

        this.setValue = function (value) {
            this.value = value;
            this.selectFieldList.setSelectedField(value.entityField);
            this.filter.setValue(value);
        };

        this.getValue = function () {
            return this.filter.getValue();
        }.bind(this);

        var renderField = function (field) {
            this.filter = new Greenmile.PanelBuilder.Fields.Base(field, entity);
            var container = this.rootEl.querySelector('.' + fieldContainerClass);
            container.innerHTML = '';
            container.appendChild(this.filter.render());
            this.filter.postRender();

        }.bind(this);

        var renderFilterByLine = function () {
            var fieldContainer = document.createElement('div');
            this.selectFieldList = new Greenmile.PanelBuilder.SelectFieldList(entity);

            fieldContainer.className = fieldContainerClass;
            this.selectFieldList.addClickEventListener(renderField);
            this.selectFieldList.render();

            this.selectFieldList.beforeCreateList = function () {
                this.reduceToFieldTypes(defaultTypes);
            };


            var callbackDelete = function (e) {
                var orderContainer = e.target.parentNode;
                orderContainer.parentNode.removeChild(orderContainer);

                delete manager.filters[uuid];
            }.bind(this);

            this.rootEl.appendChild(this.selectFieldList.elFieldList);
            this.rootEl.appendChild(fieldContainer);
            this.rootEl.appendChild(Greenmile.PanelBuilder.Utils.getBtnDelete(callbackDelete));

            renderField();

        }.bind(this);

        this.render = function () {

            renderFilterByLine();

            return this.rootEl;
        };

        this.postRender = function () {
            if (this.filter.postRender) {
                this.filter.postRender();
            }
        };
    }

    return FilterBy;

}());